import * as React from "react";
import { LoaderCircle } from "lucide-react";

export const LoadingIcon = (): React.ReactElement => {
  return (
    <div className="flex items-center justify-center h-screen">
      <LoaderCircle className="animate-spin w-12 h-12" />
    </div>
  );
};
